import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/user/getTipoUsers.php';

export default function getTipoUsers({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}